import React, { useState, useRef } from "react";
import * as pdfjsLib from "pdfjs-dist";
import { saveAs } from "file-saver";


pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export default function PDFToPPT({ file }) {
  const [loading, setLoading] = useState(false);
  const cancelRef = useRef(false);

  React.useEffect(() => {
    if (!file) {
      setLoading(false);
    }
    // Don't auto-convert on file change
    // eslint-disable-next-line
  }, [file]);

  const handleConvert = async () => {
    if (!file) return;
    setLoading(true);
    cancelRef.current = false;
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const pptx = new window.PptxGenJS();
    for (let i = 1; i <= pdf.numPages; i++) {
      if (cancelRef.current) {
        setLoading(false);
        return;
      }
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: 2 });
      const canvas = document.createElement("canvas");
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      const ctx = canvas.getContext("2d");
      await page.render({ canvasContext: ctx, viewport }).promise;
      const imgData = canvas.toDataURL("image/png");
      pptx.addSlide().addImage({ data: imgData, x: 0, y: 0, w: pptx.width, h: pptx.height });
    }
    await pptx.writeFile({ fileName: "converted.pptx" });
    setLoading(false);
  };

  const handleCancel = () => {
    cancelRef.current = true;
    setLoading(false);
  };

  return (
    <div>
      {!file && (
        <div style={{ color: '#c00', fontSize: 17, margin: '24px 0', textAlign: 'center', fontWeight: 500 }}>
          No file selected. Please upload a PDF file to begin.
        </div>
      )}
      {file && !loading && (
        <button onClick={handleConvert} style={{ padding: '10px 24px', fontSize: 16, borderRadius: 8, background: '#007bff', color: '#fff', border: 'none', marginBottom: 16 }}>Convert</button>
      )}
      {loading && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>Converting...</span>
          <button onClick={handleCancel} style={{ color: 'red', marginLeft: 8 }}>Cancel</button>
        </div>
      )}
    </div>
  );
}
